import { frontendURL } from 'dashboard/helper/URLHelper';

// A CAIXA DE ENTRADA ANTIGA FOI APOSENTADA (07/10/2026).
//
// Era a tela que o sino antigo abria: lista de notificações à esquerda e a
// conversa ao lado. Victor achou "bagunçada", e ela repetia o que já existe
// melhor em outro lugar — a lista mora na central de notificações
// (`/notifications`) e a conversa em Conversas. O sino novo leva direto ao
// destino (`destinoDaNotificacao.js`) e nenhum menu aponta para cá.
//
// Os endereços continuam vivos só para quem guardou um link: a caixa vazia vai
// para a central de notificações; uma conversa vai para a mesma conversa em
// Conversas. Os nomes das rotas ficam porque partes do app ainda os conhecem
// (barra do celular, atalhos, reconexão).
export const routes = [
  {
    path: frontendURL('accounts/:accountId/inbox-view'),
    name: 'inbox_view',
    redirect: to => ({
      name: 'notifications_index',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/inbox-view/:type/:id'),
    name: 'inbox_view_conversation',
    redirect: to =>
      to.params.type === 'conversation'
        ? {
            name: 'inbox_conversation',
            params: {
              accountId: to.params.accountId,
              conversation_id: to.params.id,
            },
          }
        : {
            name: 'notifications_index',
            params: { accountId: to.params.accountId },
          },
  },
];
